import React from "react";
import { DropdownItemProps } from "./types";
import { Tooltip } from "ui/components/Tooltip";

const DropdownItem: React.FC<DropdownItemProps> = (
  props: DropdownItemProps
) => {
  const { value, text, image, onClick, tooltip } = props;


  return (
    <>
      <li
        className="text-[#344054] relative cursor-default select-none py-3 pl-2 pr-2 border-t hover:bg-blue-600 hover:cursor-pointer hover:text-white "
        id="listbox-option-0"
        role="option"
        aria-selected={false}
        onClick={(e) => onClick(e, value)}
        value={value}
      >
        <div className="flex items-center">
          {/*
            Popis nije virtualiziran, pa bi se inače sve sličice tražile čim se izbornik otvori — kod
            modela i tipova vozila to su deseci slika iz CVH-a. `lazy` ih odgađa dok redak nije
            blizu vidljivog dijela, a `async` ne blokira pomicanje popisa dok se slika dekodira.
          */}
          {image && (
            tooltip ? (
              <Tooltip
                trigger={
                  <img
                    src={image}
                    alt=""
                    loading="lazy"
                    decoding="async"
                    className="w-6 max-h-5 object-cover flex-shrink-0 rounded-full cursor-help"
                  />
                }
                position="bottom-right"
                size="medium"
              >
                {tooltip}
              </Tooltip>
            ) : (
              <img
                src={image}
                alt=""
                loading="lazy"
                decoding="async"
                className="w-6 max-h-5 object-cover flex-shrink-0 rounded-full"
              />
            )
          )}
          <span className={`font-normal ml-1 text-sm ${typeof text === "string" ? "block truncate" : "flex-1"}`}>{text}</span>
        </div>
      </li>
    </>
  );
};

export default React.memo(DropdownItem);
